import defs from '../_core/defs.js';
// checks is a key present in data keys list
export default function isDataKey(key) {
  var def = defs.get(this);
  /* istanbul ignore if */
  if (!def) {
    return false;
  }
  return key in def.keys;
}